module.exports = __webpack_public_path__ + "img/kanelsnurrer2.5b733310.jpg";